import { createStore, combineReducers, applyMiddleware } from 'redux';
import ReduxThunk from 'redux-thunk';
import page from './services/page/reducer';
import signup from './services/signup/reducer';

import { composeWithDevTools } from 'redux-devtools-extension';

export default createStore(
  combineReducers({ page, signup }),
  composeWithDevTools(applyMiddleware(ReduxThunk))
);
